@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.wrapper {
  border-bottom: var(--default--border-color--6) 1px solid;
  padding-top: @space-16;
  padding-bottom: @space-8;
}

.header {
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 14px;
  line-height: 24px;
  font-weight: @bold;
  margin: @space-0;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 0 @space-8;

  .detail-text > :last-child {
    justify-self: end;
  }
}

.detail-text {
  display: contents;
  font-size: 12px;
  line-height: 20px;
  color: var(--default--text-color--6);
}

.toggle-addon-btn {
  font-size: 12px;
}

.warning-icon {
  color: var(--warning--icon--fill-color--1);
  margin-left: @space-4;
}
